module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Næste","track":"Next"}}